<template>
  <section class="section" id="inventories-refills-section">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <inventories-refills-title
        :storeId="storeBeingManaged._id"
        :storeName="storeBeingManaged.storeInfo.name"
        @get-inventories-refills="getInventoriesRefills"
        @update-dates="updateDates"
        @update-store="updateStore"
        @download-inventories-refills-report="downloadInventoriesRefillsReport"
      />

      <inventories-refills-table
        :inventoriesRefills="inventoriesRefillsReverse"
        :store="store"
      />
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import { mapGetters } from "vuex";
import inventoriesRefillsTitle from "./InventoriesRefillsTitle";
import inventoriesRefillsTable from "./InventoriesRefillsTable";

export default {
  mixins: [common],

  components: {
    inventoriesRefillsTitle,
    inventoriesRefillsTable
  },

  data() {
    return {
      isLoading: false,
      dates: [],
      store: undefined,
      storeName: null
    };
  },

  methods: {
    getInventoriesRefills() {
      this.isLoading = true;
      this.$store
        .dispatch("getInventoriesRefills", {
          storeId: this.store,
          dates: this.dates
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateStore(store) {
      this.store = store ? store.split("|")[0] : "";
      this.storeName = store
        ? store.split("|")[1]
        : this.$t("common.allStores");
    },

    updateDates(dates) {
      this.dates[0] = dates
        ? this.moment(dates[0]).format("YYYY-MM-DD")
        : this.moment().format("YYYY-MM-DD");

      this.dates[1] = dates
        ? this.moment(dates[1]).format("YYYY-MM-DD")
        : this.moment().format("YYYY-MM-DD");
    },

    downloadInventoriesRefillsReport() {
      this.isLoading = true;
      this.$store
        .dispatch("downloadInventoriesRefillsReport", {
          dates: this.dates,
          storeId: this.store
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters([
      "storeBeingManaged",
      "inventoriesRefillsReverse",
      "permissions"
    ])
  },

  mounted() {
    this.updateDates();
    this.getInventoriesRefills();
  },

  created() {
    this.store = this.storeBeingManaged._id;
    this.storeName = this.storeBeingManaged.storeInfo.name;
  }
};
</script>

<style scoped>
#inventories-refills-section {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
